import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { FlatButton, SelectField, MenuItem, IconButton, IconMenu } from 'material-ui';

import { browserHistory, Link } from 'react-router';
import {
    fetchLatestEventsForStage,
    fetchLatestEventsForStageKey,
    fetchComingEventsForStage,
    fetchComingEventsForStageKey
} from '../../../actions/events';
import Match from '../EventCell';
import moment from 'moment';
import IconWidget from 'material-ui/svg-icons/action/code';
class TournamentHomeSMB extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount = () => {
        let { dispatch, fetchLatestEventsForStage, params } = this.props;

        dispatch(fetchLatestEventsForStage(params.stageId));
        dispatch(fetchComingEventsForStage(params.stageId));
    };

    componentWillReceiveProps = nextProps => {
        let { dispatch, fetchLatestEventsForStage, params } = this.props;

        if (+this.props.params.stageId !== +nextProps.params.stageId) {
            dispatch(fetchLatestEventsForStage(+nextProps.params.stageId));
            dispatch(fetchComingEventsForStage(+nextProps.params.stageId));
        }
    };

    renderRoundSelect() {
        let {
            params: { tournamentId, seasonId, sport, stageId, round },
            tournament,
            stage,
            stages,
            events = [],
            comingEvents = []
        } = this.props;

        if (stage.roundsList.length < 2) return;

        let currentRound = _.find(stage.roundsList, r => r.isCurrent);
        return (
            <span>
                <IconMenu
                    style={{ marginLeft: 15 }}
                    desktop
                    iconButtonElement={
                        <FlatButton
                            label={round ? `Round ${round}` : 'Select round'}
                            labelPosition="after"
                            icon={<IconWidget />}
                            primary
                        />
                    }
                    autoWidth
                    onChange={(event, value) => {
                        if (value === null) {
                            browserHistory.push(
                                `/sm/browser/${sport}/tournaments/${tournamentId}/${seasonId}/stages/${stageId}`
                            );
                        } else {
                            browserHistory.push(
                                `/sm/browser/${sport}/tournaments/${tournamentId}/${seasonId}/stages/${stageId}/rounds/${encodeURIComponent(
                                    value
                                )}`
                            );
                        }
                    }}
                    value={round || null}
                >
                    <MenuItem key={'all'} value={null} primaryText={'All Rounds'} />
                    {_.sortBy(stage.roundsList, r => +r.name).map(r => (
                        <MenuItem key={r.name} value={r.name} primaryText={r.name} />
                    ))}
                </IconMenu>
                {currentRound &&
                    round + '' !== currentRound.name + '' && (
                        <FlatButton
                            href={`/sm/browser/${sport}/tournaments/${tournamentId}/${seasonId}/stages/${stageId}/rounds/${encodeURIComponent(
                                currentRound.name
                            )}`}
                            label={`Go to current round (${currentRound.name})`}
                            labelPosition="after"
                            primary
                        />
                    )}
            </span>
        );
    }

    render() {
        let {
            params: { tournamentId, seasonId, sport, stageId },
            tournament,
            stage,
            stages,
            events = [],
            comingEvents = []
        } = this.props;

        if (!stage) return <div />;
        let currentRound = _.find(stage.roundsList, r => r.isCurrent);
        return (
            <div>
                <div>
                    <h2 style={{ marginBottom: 0 }}>
                        <Link to={`/sm/browser/${sport}/tournaments/${tournamentId}/${seasonId}/stages/${stageId}`}>
                            {stage && stage.name}
                        </Link>
                        {this.renderRoundSelect()}
                    </h2>
                </div>
                {this.props.children}
            </div>
        );
    }
}

export default connect(
    (state, props) => {
        let ids = _.get(state, `query.entities[${fetchLatestEventsForStageKey(props.params.stageId)}]`, []);
        let cids = _.get(state, `query.entities[${fetchComingEventsForStageKey(props.params.stageId)}]`, []);

        let events = _.get(state, `query.entities.events`, []);

        return {
            events: ids.map(id => events[id]),
            comingEvents: cids.map(id => events[id]),
            tournament: _.get(state.smBrowser, 'tournament'),
            stages: _.get(state.smBrowser, 'season.stages', []),
            stage: _.chain(state.smBrowser)
                .get('season.stages', [])
                .find(s => +s.id === +props.params.stageId)
                .value()
        };
    },
    dispatch => ({
        dispatch,
        fetchLatestEventsForStage,
        fetchComingEventsForStage
    })
)(TournamentHomeSMB);



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/TournamentStageHost.js
 **/